export default {"src":"/_next/static/media/puc.25575b66.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};